export default { sha: '6914de37f99fda50f6162c8309e8800cb03e7d46', buildNumber: 'undefined' }
